/**
 * Data Access Object for the employee endpoint.
 *
 * @module app.dao
 * @license Copyright 2013 (c) RISE Ges.m.b.H.
 *  ____   ___  ____   _____
 * |  _ \  | | / ___| | ____|
 * | |_) | | | \___ \ |  _|
 * |  _ <  | |  ___) || |___
 * |_| \_\ |_| |____/ |_____|
 *
 */
(function(rise, app) {
    "use strict";

    var Rpc = rise.Rpc;
    var log = rise.logging.getLogger("dao.employee");

    /*** Export Dao ***/
    app.dao.employeeDao = new EmployeeDao();

    /**
     * @constructor
     */
    function EmployeeDao() {
        // call parent constructor
        rise.Dao.call(this, app.model.Employee, new Rpc('/rpc/employee'));
    }

    // extend the parent Dao prototype
    $.extend(EmployeeDao.prototype, Object.create(rise.Dao.prototype));

    EmployeeDao.prototype.listAll = function(params) {
        log.info('List all Employees');
        var deferred = new $.Deferred();
        var self = this;

        self.rpc.invoke('list_all', params)
            .done(function(data) {
                if (data.length === 0) {
                    log.info('No Employee data sets found');
                    deferred.resolve([]);
                } else {
                    log.info('Received %s Employee(s)', data.length);
                    deferred.resolve(data.map(function(d) {
                        return new app.dto.UserListDto(d);
                    }));
                }
            })
            .fail(function(error) {
                log.error('Fetching all Employee failed. %s', error.message);
                deferred.reject(error);
            });

        return deferred.promise();
    };

    EmployeeDao.prototype.getAllWithoutUserTags = function() {
        var deferred = new $.Deferred();
        var self = this;

        self.rpc.invoke('get_all_without_user_tags')
            .done(function(data) {
                if (data.length === 0) {
                    deferred.resolve([]);
                } else {
                    deferred.resolve(data.map(function(e) {
                        return new app.model.Employee(e);
                    }));
                }
            })
            .fail(function(error) {
                deferred.reject(error);
            });

        return deferred.promise();
    };

    EmployeeDao.prototype.getAllForCustomer = function(customerId) {
        var deferred = new $.Deferred();
        var self = this;

        self.rpc.invoke('get_all_for_customer', {'customer_id': customerId})
            .done(function(data) {
                if (data.length === 0) {
                    deferred.resolve([]);
                } else {
                    deferred.resolve(data.map(function(e) {
                        return new app.model.Employee(e);
                    }));
                }
            })
            .fail(function(error) {
                deferred.reject(error);
            });

        return deferred.promise();
    };

})(window.rise, window.app);
